import React, { useEffect } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import LoanSimulation from './pages/LoanSimulation/index';
import ClientRegistration from './pages/ClientRegistration/index';
import RegistrationLinks from './pages/RegistrationLinks';
import AccessBlocked from './pages/AccessBlocked';
import Contracts from './pages/Contracts';
import Financial from './pages/Financial';
import MyContracts from './pages/MyContracts';
import RejectedContracts from './pages/RejectedContracts';
import Sellers from './pages/Sellers';
import Collections from './pages/Collections';
import CollectionsV2 from './pages/CollectionsV2';
import ManagerCollections from './pages/ManagerCollections';
import Clients from './pages/Clients';
import ManagerAgenda from './pages/ManagerAgenda';
import Overdue from './pages/Overdue';
import Curvas from './pages/Curvas';
import AllClients from './pages/AllClients';
import DailySales from './pages/DailySales';
import Cash from './pages/Cash';
import ContractEvaluations from './pages/ContractEvaluations';
import CaixaV2 from './pages/CaixaV2';
import CaixaV3 from './pages/CaixaV3';
import UnitsManagement from './pages/UnitsManagement';
import Notifications from './pages/Notifications';
import ClientTransfer from './pages/ClientTransfer';
import ClientEdit from './pages/ClientEdit';
import SellerClientEdit from './pages/SellerClientEdit';
import ClientEditReview from './pages/ClientEditReview';
import CircuitSettings from './pages/CircuitSettings';
import VendorReview from './pages/VendorReview';
import MyProfile from './pages/MyProfile';
import Metas from './pages/Metas';
import LeadCapture from './pages/LeadCapture';
import MyLeads from './pages/MyLeads';
import LeadsManager from './pages/LeadsManager';
import FinancialDashboard from './pages/FinancialDashboard';
import WhatsAppSettings from './pages/WhatsAppSettings';
import PixControl from './pages/PixControl';
import WhatsAppLogs from './pages/WhatsAppLogs';
import MyWhatsApp from './pages/MyWhatsApp';
import Blacklist from './pages/Blacklist';
import SellersActivity from './pages/SellersActivity';
import SellerActivityDetail from './pages/SellerActivityDetail';
import AiAgent from './pages/AiAgent';
import InstallApp from './pages/InstallApp';
import AppCifrao from './pages/AppCifrao';
import AppStatusBanners from './components/AppStatusBanners';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { INSTALL_PATH, isLeadsDomain } from './lib/pwa';

function PrivateRoute({ children }: { children: React.ReactNode }) {
  const { user } = useAuth();
  return user ? <>{children}</> : <Navigate to="/login" />;
}

function ScrollToTop() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return null;
}

function App() {
  if (isLeadsDomain()) {
    return (
      <Routes>
        <Route path="/cadastro/:slug" element={<ClientRegistration />} />
        <Route path="/leads/:slug" element={<LeadCapture />} />
        <Route path="*" element={<AccessBlocked />} />
      </Routes>
    );
  }

  return (
    <AuthProvider>
      <ScrollToTop />
      <AppStatusBanners />
      <Routes>
        <Route path="/" element={<Navigate to="/login" />} />
        <Route path="/login" element={<Login />} />
        <Route path={INSTALL_PATH} element={<InstallApp />} />
        <Route path="/cadastro/:slug" element={<ClientRegistration />} />
        <Route path="/leads/:slug" element={<LeadCapture />} />
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        >
          <Route path="loan-simulation" element={<LoanSimulation />} />
          <Route path="novo-contrato" element={<LoanSimulation />} />
          <Route path="contracts" element={<Contracts />} />
          <Route path="registration-links" element={<RegistrationLinks />} />
          <Route path="vendor-review" element={<VendorReview />} />
          <Route path="financial" element={<Financial />} />
          <Route path="my-contracts" element={<MyContracts />} />
          <Route path="rejected-contracts" element={<RejectedContracts />} />
          <Route path="sellers" element={<Sellers />} />
          <Route path="collections" element={<Collections />} />
          <Route path="collections-v2" element={<CollectionsV2 />} />
          <Route path="clients" element={<Clients />} />
          <Route path="manager-agenda" element={<ManagerAgenda />} />
          <Route path="overdue" element={<Overdue />} />
          <Route path="curvas" element={<Curvas />} />
          <Route path="all-clients" element={<AllClients />} />
          <Route path="daily-sales" element={<DailySales />} />
          <Route path="cash" element={<Cash />} />
          <Route path="caixa-v2" element={<CaixaV2 />} />
          <Route path="caixa-v3" element={<CaixaV3 />} />
          <Route path="contract-evaluations" element={<ContractEvaluations />} />
          <Route path="units" element={<UnitsManagement />} />
          <Route path="notifications" element={<Notifications />} />
          <Route path="client-transfer" element={<ClientTransfer />} />
          <Route path="client-edit" element={<ClientEdit />} />
          <Route path="seller-client-edit" element={<SellerClientEdit />} />
          <Route path="client-edit-review" element={<ClientEditReview />} />
          <Route path="circuit-settings" element={<CircuitSettings />} />
          <Route path="metas" element={<Metas />} />
          <Route path="my-profile" element={<MyProfile />} />
          <Route path="my-leads" element={<MyLeads />} />
          <Route path="leads-manager" element={<LeadsManager />} />
          <Route path="financial-dashboard" element={<FinancialDashboard />} />
          <Route path="whatsapp-settings" element={<WhatsAppSettings />} />
          <Route path="whatsapp-logs" element={<WhatsAppLogs />} />
          <Route path="meu-whatsapp" element={<MyWhatsApp />} />
          <Route path="blacklist" element={<Blacklist />} />
          <Route path="team-activity" element={<SellersActivity />} />
          <Route path="team-activity/:userId" element={<SellerActivityDetail />} />
          <Route path="ai-agent" element={<AiAgent />} />
          <Route path="pix-control" element={<PixControl />} />
          <Route path="app-cifrao" element={<AppCifrao />} />
        </Route>
      </Routes>
    </AuthProvider>
  );
}

export default App;